export default {
  "create-address-success": {
    EN: "Successfully created new address",
  },
  "update-proposal-content-success": {
    EN: "Successfully updated proposal content",
  },
  "update-proposal-content-failure": {
    EN: "Faild to  update proposal content",
  },
  "create-address-failure": {
    EN: "Failed to create new address",
  },
  "create-checklist-item-success": {
    EN: "Successfully created checklist item",
  },
  "create-checklist-item-failure": {
    EN: "Failed to create checklist item",
  },
  "update-checklist-item-success": {
    EN: "Successfully updated checklist item",
  },
  "update-checklist-item-failure": {
    EN: "Failed to update checklist item",
  },
  "delete-checklist-item-success": {
    EN: "Successfully deleted checklist item",
  },
  "delete-checklist-item-failure": {
    EN: "Failed to delete checklist item",
  },
  "update-address-success": {
    EN: "Success updating address!",
  },
  "update-address-failure": {
    EN: "Failed to update address",
  },
  "delete-address-success": {
    EN: "Success deleting the address!",
  },
  "delete-address-failure": {
    EN: "Failed to delete the address. Please check if the address is primary or not",
  },
  "create-additional-cost-success": {
    EN: "Successfully created new additional cost",
  },
  "create-additional-cost-failure": {
    EN: "Failed to create new additional cost",
  },
  "update-additional-cost-success": {
    EN: "Success updating additional cost!",
  },
  "update-additional-cost-failure": {
    EN: "Failed to update additional cost",
  },
  "delete-additional-cost-success": {
    EN: "Success deleting the additional cost!",
  },
  "delete-additional-cost-failure": {
    EN: "Failed to delete the additional cost",
  },
  "create-equipment-piece-success": {
    EN: "Successfully created new equipment piece",
  },
  "create-equipment-piece-failure": {
    EN: "Failed to create new equipment piece",
  },
  "update-equipment-piece-success": {
    EN: "Success updating equipment piece!",
  },
  "update-equipment-piece-failure": {
    EN: "Failed to update equipment piece",
  },
  "delete-equipment-piece-success": {
    EN: "Success deleting the equipment piece!",
  },
  "delete-equipment-piece-failure": {
    EN: "Failed to delete the equipment piece",
  },
  "create-transfer-truck-success": {
    EN: "Successfully created new transfer truck",
  },
  "create-transfer-truck-failure": {
    EN: "Failed to create new transfer truck",
  },
  "update-transfer-truck-success": {
    EN: "Success updating transfer truck!",
  },
  "update-transfer-truck-failure": {
    EN: "Failed to update transfer truck",
  },
  "delete-transfer-truck-success": {
    EN: "Success deleting the transfer truck!",
  },
  "delete-transfer-truck-failure": {
    EN: "Failed to delete the transfer truck",
  },
  "create-plant-success": {
    EN: "Successfully created new plant",
  },
  "create-plant-failure": {
    EN: "Failed to create new plant",
  },
  "update-plant-success": {
    EN: "Success updating plant!",
  },
  "update-plant-failure": {
    EN: "Failed to update plant",
  },
  "delete-plant-success": {
    EN: "Success deleting the plant!",
  },
  "delete-plant-failure": {
    EN: "Failed to delete the plant",
  },
  "create-plant-product-type-success": {
    EN: "Material created successfully!",
  },
  "create-plant-product-type-failure": {
    EN: "Failed to create material",
  },
  "create-crew-success": {
    EN: "Successfully added new crew",
  },
  "create-crew-failure": {
    EN: "Failed to add new crew",
  },
  "update-crew-success": {
    EN: "Success updating crew!",
  },
  "update-crew-failure": {
    EN: "Failed to update crew",
  },
  "delete-crew-success": {
    EN: "Success removing the crew!",
  },
  "delete-crew-failure": {
    EN: "Failed to remove the crew",
  },
  "update-email-template-success": {
    EN: "Email Template updated successfully",
  },
  "update-email-template-failed": {
    EN: "Failed to update Email Template",
  },
  "update-email-template-preview-success": {
    EN: "Email Template Preview sent successfully",
  },
  "update-email-template-preview-failed": {
    EN: "Failed to send Email Template Preview",
  },
  "get-email-template-failed": {
    EN: "Failed to get Email Template",
  },
  "create-employee-success": {
    EN: "Employee created successfully!",
  },
  "create-employee-failure": {
    EN: "Could not create employee",
  },
  "update-employee-success": {
    EN: "Employee updated successfully!",
  },
  "update-employee-failure": {
    EN: "Could not update employee",
  },
  "delete-employee-success": {
    EN: "Employee deleted successfully!",
  },
  "delete-employee-failure": {
    EN: "Could not delete employee",
  },
  "archive-employee-success": {
    EN: "Employee archived",
  },
  "archive-employee-failure": {
    EN: "Could not archive employee",
  },
  "restore-employee-success": {
    EN: "Employee restored",
  },
  "restore-employee-failure": {
    EN: "Could not restore employee",
  },
  "archive-user-success": {
    EN: "User archived",
  },
  "archive-user-failure": {
    EN: "Could not archive user",
  },
  "restore-user-success": {
    EN: "User restored",
  },
  "restore-user-failure": {
    EN: "Could not restore user",
  },
  "update-success": {
    EN: "Organization updated successfully!",
  },
  "update-failure": {
    EN: "Could not update Organization",
  },
  "add-document-success": {
    EN: "Document added successfully!",
  },
  "add-document-failure": {
    EN: "Could not add document",
  },
  "delete-document-success": {
    EN: "Document deleted successfully!",
  },
  "delete-document-failure": {
    EN: "Could not delete document",
  },
  "get-linked-service-auth-url-success": {
    EN: "Processing...",
  },
  "get-linked-service-auth-url-failure": {
    EN: "Could not link service",
  },
  "finalize-linked-service-account-success": {
    EN: "Service Linked!",
  },
  "finalize-linked-service-account-failure": {
    EN: "Could not link service",
  },
  "save-quickbooks-income-account-success": {
    EN: "Settings saved!",
  },
  "save-quickbooks-income-account-failure": {
    EN: "Could not save Quickbooks settings",
  },
  "save-quickbooks-integration-data-success": {
    EN: "Data saved!",
  },
  "save-quickbooks-integration-data-failure": {
    EN: "Could not save data to sync with Quickbooks",
  },
  "create-job-invoice-on-linked-service-success": {
    EN: "Operation successful!",
  },
  "create-job-invoice-on-linked-service-failure": {
    EN: "Operation failed",
  },
  "unlink-service-success": {
    EN: "Service unlinked",
  },
  "unlink-service-failure": {
    EN: "Could not unlink service",
  },
  "generate-report-success": {
    EN: "Report generated!",
  },
  "generate-report-failure": {
    EN: "Something went wrong",
  },
  "generate-data-report-success": {
    EN: "Report generated!",
  },
  "generate-data-report-failure": {
    EN: "Something went wrong",
  },
  "create-data-upload-success": {
    EN: "Successfully created new data import",
  },
  "create-data-upload-failure": {
    EN: "Failed to create new data import",
  },
  "update-sales-tax-success": {
    EN: "Saved!",
  },
  "update-sales-tax-failure": {
    EN: "Could not update sales tax",
  },
  "update-organization-proposal-defaults-success": {
    EN: "Proposal defaults updated",
  },
  "update-organization-proposal-defaults-failure": {
    EN: "Could not update proposal defaults",
  },
  "remove-job-from-queue-success": {
    EN: "Successfully deleted Job from queue",
  },
  "remove-job-from-queue-failure": {
    EN: "Failed to delete Job from queue",
  },
  "delete-project-file-success": {
    EN: "Deleted!",
  },
  "delete-project-file-failure": {
    EN: "Failed to delete",
  },
  "create-project-file-folder-success": {
    EN: "Folder Created!",
  },
  "create-project-file-folder-failure": {
    EN: "Could not create folder",
  },
  "add-project-file-success": {
    EN: "Uploaded!",
  },
  "add-project-file-failure": {
    EN: "Upload failed",
  },
  "update-roles-with-permissions-success": {
    EN: "Permissions updated successfully",
  },
  "update-roles-with-permissions-failure": {
    EN: "Failed to update Permissions",
  },
  "update-conversion-factor-override-success": {
    EN: "Conversion factors updated successfully",
  },
  "update-conversion-factor-override-failed": {
    EN: "Failed to update conversion factors",
  },
  "update-proposal-sent-email-text-success": {
    EN: "Proposal sent email text updated successfully",
  },
  "update-proposal-sent-email-text-failure": {
    EN: "Failed to update proposal sent email text",
  },
  "update-invoice-payment-terms-success": {
    EN: "Payment terms updated successfully",
  },
  "update-invoice-payment-terms-failure": {
    EN: "Failed to update payment terms",
  },
  "update-invoice-email-text-success": {
    EN: "Invoice email text updated successfully",
  },
  "update-invoice-email-text-failure": {
    EN: "Failed to update invoice email text",
  },
  "send-invoice-success": {
    EN: "Invoice sent successfully",
  },
  "send-invoice-failure": {
    EN: "Failed to send invoice",
  },
  "preview-invoice-success": {
    EN: "Invoice preview generated successfully",
  },
  "preview-invoice-failure": {
    EN: "Failed to generate invoice preview",
  },
  "update-proposal-layout-content-settings-success": {
    EN: "Layout content settings updated successfully!",
  },
  "update-proposal-layout-content-settings-failure": {
    EN: "Something went wrong.",
  },
  "create-custom-content-type-success": {
    EN: "Custom proposal term created successfully!",
  },
  "create-custom-content-type-failure": {
    EN: "Failed to create custom proposal term.",
  },
};
